import * as React from 'react';

import { cn } from '@/utils';

import mathleteBanner from '../../assets/mathlete_banner.png';
import successIcon from '../../assets/success.png';
import type { MathleteBatch } from '../../types';

import { BatchDetailsCard } from './batch-details-card';

interface MathleteSuccessViewProps {
  selectedBatch: MathleteBatch | null;
}

export const MathleteSuccessView: React.FC<MathleteSuccessViewProps> = ({
  selectedBatch,
}) => {
  return (
    <div
      className={cn(
        'rounded-lg flex flex-col',
        'h-[61.4vh] w-full p-1',
        'md:h-[640px] md:w-[840px] md:p-3'
      )}
    >
      <div
        className={cn(
          'rounded-[10px] bg-no-repeat bg-[length:100%_100%]',
          'm-2 mb-0 p-[1.7rem]',
          'md:m-0 md:p-[5.5rem]'
        )}
        style={{
          backgroundImage: `url(${mathleteBanner})`,
        }}
      >
        <p className="text-base text-white">You have been enrolled in</p>
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-1">
          Mathlete 101
        </h2>
      </div>

      <div className="flex flex-col justify-center items-center flex-grow pt-8">
        <img src={successIcon} alt="Success" className="mb-8" />
        <p className="text-base font-semibold text-white mb-4 text-center">
          Congratulations! You have selected batch successfully
        </p>
        {selectedBatch ? (
          <BatchDetailsCard batch={selectedBatch} spacing={2} />
        ) : null}
      </div>
    </div>
  );
};
